import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faAngleDoubleLeft, faAsterisk, faCloud} from '@fortawesome/free-solid-svg-icons';
import {faAngleDoubleRight} from '@fortawesome/free-solid-svg-icons';
import {faBan} from '@fortawesome/free-solid-svg-icons';
import {faCalendarAlt} from '@fortawesome/free-solid-svg-icons';
import {faCalendarCheck} from '@fortawesome/free-solid-svg-icons';
import {faCalendarTimes} from '@fortawesome/free-solid-svg-icons';
import {faChalkboard} from '@fortawesome/free-solid-svg-icons';
import {faChalkboardTeacher} from '@fortawesome/free-solid-svg-icons';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons';
import {faCircle} from '@fortawesome/free-solid-svg-icons';
import {faClone} from '@fortawesome/free-solid-svg-icons';
import {faCloudUploadAlt} from '@fortawesome/free-solid-svg-icons';
import {faCloudDownloadAlt} from '@fortawesome/free-solid-svg-icons';
import {faCog} from '@fortawesome/free-solid-svg-icons';
import {faCogs} from '@fortawesome/free-solid-svg-icons';
import {faDatabase} from '@fortawesome/free-solid-svg-icons';
import {faEquals} from '@fortawesome/free-solid-svg-icons';
import {faExchangeAlt} from '@fortawesome/free-solid-svg-icons';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';
import {faEye} from '@fortawesome/free-solid-svg-icons';
import {faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import {faFileAlt} from '@fortawesome/free-solid-svg-icons';
import {faFileArchive} from '@fortawesome/free-solid-svg-icons';
import {faArchive} from '@fortawesome/free-solid-svg-icons';
import {faFileImage} from '@fortawesome/free-solid-svg-icons';
import {faFilePdf} from '@fortawesome/free-solid-svg-icons';
import {faFileWord} from '@fortawesome/free-solid-svg-icons';
import {faFilter} from '@fortawesome/free-solid-svg-icons';
import {faHistory} from '@fortawesome/free-solid-svg-icons';
import {faIdCard} from '@fortawesome/free-solid-svg-icons';
import {faKey} from '@fortawesome/free-solid-svg-icons';
import {faMagic} from '@fortawesome/free-solid-svg-icons';
import {faMinusCircle} from '@fortawesome/free-solid-svg-icons';
import {faPlusCircle} from '@fortawesome/free-solid-svg-icons';
import {faRocket} from '@fortawesome/free-solid-svg-icons';
import {faSave} from '@fortawesome/free-solid-svg-icons';
import {faSchool} from '@fortawesome/free-solid-svg-icons';
import {faSlidersH} from '@fortawesome/free-solid-svg-icons';
import {faSpinner} from '@fortawesome/free-solid-svg-icons';
import {faSync} from '@fortawesome/free-solid-svg-icons';
import {faSyncAlt} from '@fortawesome/free-solid-svg-icons';
import {faTools} from '@fortawesome/free-solid-svg-icons';
import {faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import {faTv} from '@fortawesome/free-solid-svg-icons';
import {faUniversity} from '@fortawesome/free-solid-svg-icons';
import {faGlobe} from '@fortawesome/free-solid-svg-icons';
import {faUnlock} from '@fortawesome/free-solid-svg-icons';
import {faUserGraduate} from '@fortawesome/free-solid-svg-icons';
import {faUserFriends} from '@fortawesome/free-solid-svg-icons';
import {faUsers} from '@fortawesome/free-solid-svg-icons';
import {faUserTie} from '@fortawesome/free-solid-svg-icons';
import {faUser} from '@fortawesome/free-solid-svg-icons';
import {faWindowMaximize} from '@fortawesome/free-regular-svg-icons';
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons';
import {faBuilding} from '@fortawesome/free-solid-svg-icons';
import {faLongArrowAltRight} from '@fortawesome/free-solid-svg-icons';
import {faLongArrowAltLeft} from '@fortawesome/free-solid-svg-icons';
import {faLock} from '@fortawesome/free-solid-svg-icons';
import {faLockOpen} from '@fortawesome/free-solid-svg-icons';
import {faRedoAlt} from '@fortawesome/free-solid-svg-icons';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';
import {faClipboardList} from '@fortawesome/free-solid-svg-icons';
import {faPoll} from '@fortawesome/free-solid-svg-icons';
import {faThLarge} from '@fortawesome/free-solid-svg-icons';
import {faFolder} from '@fortawesome/free-solid-svg-icons';
import {faTachometerAlt} from '@fortawesome/free-solid-svg-icons';
import {faEraser} from '@fortawesome/free-solid-svg-icons';
import {faWrench} from '@fortawesome/free-solid-svg-icons';
import {faLink} from '@fortawesome/free-solid-svg-icons';
import {faBullhorn} from '@fortawesome/free-solid-svg-icons';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        FontAwesomeModule
    ],
    exports: [
        FontAwesomeModule
    ]
})
export class FaIconModule {
    constructor(library: FaIconLibrary) {
        // Add an icon to the library for convenient access in other components
        library.addIcons(
            faAngleDoubleLeft,
            faAngleDoubleRight,
            faBan,
            faCalendarAlt,
            faCalendarCheck,
            faCalendarTimes,
            faChalkboardTeacher,
            faChalkboard,
            faCheckCircle,
            faChevronRight,
            faChevronLeft,
            faCircle,
            faClone,
            faCloudUploadAlt,
            faCloudDownloadAlt,
            faCog,
            faCogs,
            faDatabase,
            faEquals,
            faExchangeAlt,
            faExclamationTriangle,
            faEye,
            faEyeSlash,
            faFileAlt,
            faFileArchive,
            faArchive,
            faFileImage,
            faFilePdf,
            faFileWord,
            faFilter,
            faHistory,
            faIdCard,
            faKey,
            faLock,
            faLockOpen,
            faMagic,
            faMinusCircle,
            faPlusCircle,
            faRocket,
            faSave,
            faSchool,
            faSlidersH,
            faSpinner,
            faSync,
            faSyncAlt,
            faTools,
            faTrashAlt,
            faTv,
            faUniversity,
            faGlobe,
            faUnlock,
            faUserGraduate,
            faUserFriends,
            faUsers,
            faUserTie,
            faUser,
            faWindowMaximize,
            faExternalLinkAlt,
            faBuilding,
            faLongArrowAltRight,
            faLongArrowAltLeft,
            faRedoAlt,
            faInfoCircle,
            faClipboardList,
            faPoll,
            faThLarge,
            faFolder,
            faTachometerAlt,
            faEraser,
            faWrench,
            faCloud,
            faLink,
            faBullhorn,
            faAsterisk
        );
    }
}
